<template>
  <div>
	  {{ getInfo(data) }}
    <!--<v-select transition="" :options="options" v-model="data.status" :reduce="(option) => option.code" :disabled="data.disabled"></v-select>-->
  </div>
</template>

<script>
//import {mapGetters} from "vuex";
//import $ from "jquery";

export default {
  name: "infoColumn",
  props: {
    data: {
      type: Object,
      required: true,
    }
  },

  methods: {
    getInfo (data) {
      if (!data || !data.info) {
        return '';
      }

      let result = data.info.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, ' ');

      if (data.source) {
        result += " | Источник: " + data.source.replace(/[\\[\]]/gm, "");
      }

      return result;
    }
  },

}
</script>


<style>

</style>
